import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import {DateRangePicker, dateUtils} from '@homeaway/react-date-pickers';
import './style.less';
import {DayAvailability, CheckInCheckOut, DatePickerIcon} from '@homeaway/react-search-components';

const createDatesState = (previousCheckIn, previousCheckOut, pendingCheckIn, pendingCheckOut) => ({
    previousCheckIn,
    previousCheckOut,
    pendingCheckIn,
    pendingCheckOut
});

export default class DatePicker extends Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        checkIn: PropTypes.string,
        onInputCheckIn: PropTypes.func.isRequired,
        checkOut: PropTypes.string,
        onInputCheckOut: PropTypes.func.isRequired,
        labels: PropTypes.shape({
            checkIn: PropTypes.string,
            checkOut: PropTypes.string,
            labels: PropTypes.string,
            arrival: PropTypes.string,
            departure: PropTypes.string,
            close: PropTypes.string,
            done: PropTypes.string
        }),
        dayTemplateComponent: PropTypes.func,
        locale: PropTypes.string,
        splitDatePicker: PropTypes.bool,
        onClose: PropTypes.func,
        onOpen: PropTypes.func
    };

    static defaultProps = {
        onClose: () => {},
        onOpen: () => {},
        id: 'searchbox-datepicker',
        dayTemplateComponent: DayAvailability
    }

    state = {
        showContinueButton: !!(this.props.checkIn && this.props.checkOut),
        isDatePickerOpen: false,
        previousCheckIn: this.props.checkIn,
        previousCheckOut: this.props.checkOut,
        pendingCheckIn: null,
        pendingCheckOut: null,
        readOnly: false
    }

    triggerInputs = (checkInDate, checkOutDate) => {
        this.props.onInputCheckIn(checkInDate);
        this.props.onInputCheckOut(checkOutDate);
    }

    handleDateRangeChange = (checkInDate, checkOutDate) => {
        this.triggerInputs(checkInDate, checkOutDate);

        const hasBothDates = !!(checkInDate && checkOutDate);

        let state = {
            showContinueButton: hasBothDates
        };

        if (hasBothDates) {
            state.pendingCheckIn = checkInDate;
            state.pendingCheckOut = checkOutDate;
        }

        this.setState(state);
    };

    handleDatePickerOpen = (...args) => {
        this.setState({
            isDatePickerOpen: true,
            readOnly: true
        });

        this.props.onOpen(...args);
    }

    handleDatePickerClose = (...args) => {
        const {
            pendingCheckIn,
            pendingCheckOut
        } = this.state;

        let datesState = {};

        if (pendingCheckIn && pendingCheckOut) {
            datesState = createDatesState(pendingCheckIn, pendingCheckOut, null, null);
        }

        this.setState({
            isDatePickerOpen: false,
            readOnly: false,
            ...datesState
        });

        this.props.onClose(...args);
    }

    handleDateRangeClear = () => {
        this.setState(createDatesState(null, null, null, null));
    }

    handleCancel = () => {
        this.triggerInputs(this.state.previousCheckIn, this.state.previousCheckOut);
    }

    render() {
        const {
            checkIn,
            checkOut,
            isMobile,
            labels,
            dayTemplateComponent,
            locale,
            isOpen,
            splitDatePicker,
            id
        } = this.props;

        const {
            showContinueButton,
            isDatePickerOpen,
            readOnly
        } = this.state;

        const className = cnames('DatePicker__range', {
            'DatePicker__range--split': splitDatePicker
        });

        const dateFormatOptions = splitDatePicker ? {} : {
            month: 'short',
            day: 'numeric',
            weekday: 'short'
        };

        let checkInDate;
        let checkOutDate;

        checkInDate = dateUtils.getLocaleDateString(checkIn, locale, dateFormatOptions);
        checkOutDate = dateUtils.getLocaleDateString(checkOut, locale, dateFormatOptions);

        const modalCheckInCheckOut = (
            <CheckInCheckOut
                checkIn={checkInDate}
                checkInLabel={labels.checkIn}
                checkOutLabel={labels.checkOut}
                checkOut={checkOutDate}
                isOpen={isDatePickerOpen}
                inModal
            />
        );

        return (
            <div className={className}>
                <DateRangePicker
                    fadeOutDuration={0}
                    startDate={checkIn}
                    endDate={checkOut}
                    inputLabel1={!splitDatePicker ? labels.dates : labels.checkIn}
                    inputLabel2={labels.checkOut}
                    inputName1={'checkin'}
                    inputName2={'checkout'}
                    onDateRangeChange={this.handleDateRangeChange}
                    onDateRangeClear={this.handleDateRangeClear}
                    disableTextInput
                    closeButtonLabel={labels.close}
                    clearButtonLabel={labels.labels}
                    continueButtonLabel={labels.done}
                    dayTemplateComponent={dayTemplateComponent}
                    inputIcon1={<DatePickerIcon />}
                    inputIcon2={<DatePickerIcon />}
                    dateFormatOptions={dateFormatOptions}
                    onOpen={this.handleDatePickerOpen}
                    onClose={this.handleDatePickerClose}
                    onCancel={this.handleCancel}
                    onSubmit={this.handleSubmit}
                    modalTitle={modalCheckInCheckOut}
                    consolidateInputs={!splitDatePicker}
                    {...{isMobile, locale, showContinueButton, isOpen, readOnly, id}}
                />
                { !splitDatePicker && (checkIn || isDatePickerOpen) &&
                    <CheckInCheckOut
                        checkIn={checkInDate}
                        checkInLabel={labels.checkIn}
                        checkOutLabel={labels.checkOut}
                        checkOut={checkOutDate}
                        isOpen={isDatePickerOpen}
                    />
                }
            </div>
        );
    }
}
